type EventMap = Record<string, any>

type EventKey<KeyMap extends EventMap> = string & keyof KeyMap
type EventReceiver<KeyMap> = (params: KeyMap) => void

export interface Emitter<KeyMap extends EventMap> {
  on<Key extends EventKey<KeyMap>>(eventName: Key, fn: EventReceiver<KeyMap[Key]>): void
  off<Key extends EventKey<KeyMap>>(eventName: Key, fn: EventReceiver<KeyMap[Key]>): void
  emit<Key extends EventKey<KeyMap>>(eventName: Key, params: KeyMap[Key]): void
}

export class EventEmitter<KeyMap extends EventMap> implements Emitter<KeyMap> {
  listeners: {
    [Key in keyof EventMap]?: ((p: EventMap[Key]) => void)[]
  } = {}
  on<Key extends EventKey<KeyMap>>(eventName: Key, fn: EventReceiver<KeyMap[Key]>): void {
    this.listeners[eventName] = (this.listeners[eventName] ?? []).concat(fn)
  }
  off<Key extends EventKey<KeyMap>>(eventName: Key, fn: EventReceiver<KeyMap[Key]>): void {
    this.listeners[eventName] = (this.listeners[eventName] ?? []).filter((f) => f !== fn)
  }
  emit<Key extends EventKey<KeyMap>>(eventName: Key, data?: KeyMap[Key]): void {
    ;(this.listeners[eventName] ?? []).forEach((fn) => fn(data))
  }
}
